import $api from "../../../http";
import { MyPlace, MyStation } from "../types";

/**
 * `Ф1` (кабинет ПЗС): данные раздела «Станции».
 *
 * Два запроса, оба — «мои»: `GET /myStations` (станции по своим местам) и
 * `GET /my/places` (места и связи; отсюда — «ждёт акта» и «связь закрыта»).
 */
export default class CabinetStationsApi {
  static async getMyStations(): Promise<MyStation[]> {
    const response = await $api.get<MyStation[]>("/myStations", {
      withCredentials: true,
    });

    return response.data;
  }

  static async getMyPlaces(): Promise<MyPlace[]> {
    const response = await $api.get<MyPlace[]>("/my/places", {
      withCredentials: true,
    });

    return response.data;
  }
}
